import { useState } from "react";
import { CalculadoraINSSInputCard } from "./components/CalculadoraINSS.InputCard";
import { CalculoINSSResponse } from "./calcular-inss";
import { CalculadoraINSSResponse } from "./components/CalculadoraINSSResponse";


export default function CalculadoraINSS() {
    const [results, setResults] = useState<CalculoINSSResponse | null>(null);

    return (
        <>
            <CalculadoraINSSInputCard setResults={setResults} />
            {results && <CalculadoraINSSResponse results={results} />}

        </>
    );
}
